import changePasswordApi from './requestChangePassword';

const api = { changePasswordApi };

export default api;